import React from 'react';

import { Stack } from '@mui/material';
import { Label } from '@common/Label';
import { Expression } from '@common/Expression';
import { StaticDocumentMetadata } from '../../../tool.types';

interface Props {
  metadata: StaticDocumentMetadata;
  setToolMetadata: React.Dispatch<React.SetStateAction<StaticDocumentMetadata>>;
  toolArgumentOptions: object;
}

export const StaticDocumentExecution: React.FC<Props> = ({ metadata, setToolMetadata, toolArgumentOptions }) => {
  const updateTextField = (paramName: 'output', value: string) => {
    setToolMetadata((prevState) => ({ ...prevState, [paramName]: value }));
  };

  const tooltip =
    'Define a markdown document that the LLM will read when this tool is executed. You can insert arguments generated by the tool at runtime (Arguments Tab) by using the dynamic variable syntax: {{ tool.args.ARG_NAME }}.';

  return (
    <Stack spacing={1}>
      <Label title='Document' tooltip={tooltip} />
      <Expression
        key={`output`}
        keyProp={`output`}
        value={metadata.output}
        title={'Static Document'}
        description={tooltip}
        setValue={(newValue: string) => updateTextField('output', newValue)}
        options={toolArgumentOptions}
        placeholder='Document Content'
        minRows={12}
        maxRows={20}
      />
    </Stack>
  );
};
